import { connect } from "react-redux";

import Portfolio from "./Portfolio";

const mapStateToProps = ({ portfolios }) => ({
  portfolios,
});

export default connect(mapStateToProps)(Portfolio);
